import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitFirst'
})
export class GetPrimerString implements PipeTransform
{
  constructor() {
  }
    transform(value: string, args: any[]): string {
        if (!value) { return ''; }
        return value.split(' ')[0];
      }
}
